var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cross_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.41 12 4.3-4.29A.996.996 0 1 0 16.3 6.3L12 10.59l-4.29-4.3c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.03 0 1.42l4.3 4.29-4.3 4.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29L12 13.41l4.29 4.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41L13.41 12Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cross_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6h12v12H6z"
  })))));
};
export default SvgCross;